module.exports = {
	"version": "120",
	"version_date": "Sep 2025"
};


//////////////////
// WEBPACK FOOTER
// ./src/data/Version.json
// module id = 968
// module chunks = 0